import React from "react";
import styled from "styled-components";
import Button from "./Button";
import { portalColors } from "./BusinessPortalComponents";

const ActionButtonBase = styled(Button)`
    background: ${p => p.backgroundColor};
    border: 1px solid ${p => p.borderColor};
    color: ${p => p.color};
    width: ${p => p.width || "140px"};
    height: ${p => p.height || "42px"};
    min-height: 42px;
    border-radius: 8px;
    box-shadow: none;
`;

const SmallActionButtonBase = styled.button`
    min-width: ${p => p.minWidth || "78px"};
    min-height: ${p => p.height || "32px"};
    height: ${p => p.height || "32px"};
    padding: ${p => p.padding || "0 12px"};
    background: ${p => p.backgroundColor || portalColors.surfaceSoft};
    border: 1px solid ${portalColors.borderStrong};
    border-radius: 8px;
    box-shadow: none;
    color: ${portalColors.text};
    font-size: 11px;
    font-weight: 800;
    font-family: Manrope, Helvetica, sans-serif;
    cursor: ${p => p.disabled ? "default" : "pointer"};
    opacity: ${p => p.disabled ? 0.6 : 1};
`;

const PlaylistThumbBase = styled.div`
    width: ${p => p.size || "52px"};
    height: ${p => p.size || "52px"};
    border-radius: 50%;
    overflow: hidden;
    background: linear-gradient(140deg, #6d2cf3 0%, #6dd1ff 55%, #1a204d 100%);
    box-shadow: 0px 3px 10px #00000026;

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
    }
`;

export function PrimaryButton(props) {
    return <ActionButtonBase {...props} backgroundColor="var(--calendar-action-primary-bg, #5B6EF5)" borderColor="var(--calendar-action-primary-bg, #5B6EF5)" color="var(--calendar-action-primary-text, white)" />;
}

export function SecondaryButton(props) {
    return <ActionButtonBase {...props} backgroundColor="var(--calendar-surface, white)" borderColor="var(--calendar-border-strong, #C9D2E7)" color="var(--calendar-text, #171A22)" />;
}

export function DangerButton(props) {
    return <ActionButtonBase {...props} backgroundColor="#FFF5F5" borderColor="#FF3B3B" color="#FF3B3B" />;
}

export function BrowseButton(props) {
    return <ActionButtonBase {...props} backgroundColor="var(--calendar-action-primary-bg, #5B6EF5)" borderColor="var(--calendar-action-primary-bg, #5B6EF5)" color="var(--calendar-action-primary-text, white)" />;
}

export function SmallActionButton(props) {
    return <SmallActionButtonBase {...props} />;
}

export function PlaylistThumb(props) {
    return <PlaylistThumbBase {...props} />;
}
